import React from 'react'
import { TextInput } from 'react-native'
import tw from 'tailwind-rn'

import * as v from '../../config/variables'

type Props = React.ComponentProps<typeof TextInput>

const HGTextInput = (props: Props) => {
  const { editable } = props

  return (
    <TextInput
      {...props}
      style={[
        tw(
          [
            'bg-white rounded-md px-3 py-2 h-14 border border-gray-300',
            editable === false ? 'text-gray-600 bg-gray-200' : '',
          ].join(' ')
        ),
        { fontSize: v.FONT_SIZE_BASE },
        props.style,
      ]}
    />
  )
}

export default HGTextInput
